import NvAthenaFroala from 'athena/components/nv-athena-froala';
import t from 'react-translate';

export const getDefaultOrientation = (programName: string = '{programName}') => `
  <p class='froala-style-regular'>
    Welcome to ${programName}! This program is designed to {purpose of program}.
  </p>
  <br />
  <p class='froala-style-regular'>
    Here's what we hope you'll get out of it:
  </p>
  <ul>
    <li class='froala-style-regular' dir='ltr'>{goal or outcome}</li>
    <li class='froala-style-regular' dir='ltr'>{goal or outcome}</li>
  </ul>
  <br />
  <p class='froala-style-regular'>
    A few things to keep in mind:
  </p>
  <ul>
    <li class='froala-style-regular' dir='ltr'>{expectation or norm}</li>
    <li class='froala-style-regular' dir='ltr'>{expectation or norm}</li>
  </ul>
`;

const ProgramOrientation = () => (
  <div className='mb-6'>
    <div className='heading-5 mb-2'>
      {t.MENTORING_PROGRAMS.SETTINGS.TABS.PROGRAM_SETUP.PROGRAM_ORIENTATION.TITLE()}
    </div>
    <div className='gray-1 text-medium mb-2 description'>
      {t.MENTORING_PROGRAMS.SETTINGS.TABS.PROGRAM_SETUP.PROGRAM_ORIENTATION.DESCRIPTION()}
    </div>
    <NvAthenaFroala name='orientation' />
  </div>
);

export default ProgramOrientation;
